import { useEffect, useState, useRef } from "react";
import { ManagerGeneralDataDTO } from "../../../interface/ManagerType";
import { Address, Combobox, EInputTypes, InputTextCustom, useFormValidation } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useManagerService } from "../../../servicesHooks/Manager/useManagerService";
import { Toast, ToastMessage } from 'primereact/toast'
import InputAddress from '../../../components/InputAddress/InputAddress';
import { ComboDataDTO } from "../../../dto/ComboDataDTO";

export default function ManagerGeneralDataPanel({ setHeaderView, manager, setManager }: Readonly<{
  setHeaderView: (header: string) => void,
  manager: ManagerGeneralDataDTO, setManager: any,
}>) {
  //const dispatch = useDispatch();
  const { createManager, getManagerStates, updateManager, getAllAddressTypesForPatientEntity } = useManagerService();
  const {code, commercialname} = manager;
  const [addresses, setAddresses] = useState<Address[]>([])
  const {errors: formErrors, setErrors: setFormErrors, handleValidation} = useFormValidation(manager);

  const toast = useRef<any>(null)
  const showMessage = (ref: React.RefObject<Toast>, msg: any, severity: ToastMessage['severity']) => {
    ref.current?.show({ severity: severity, summary: msg, life: 3000 });
  };

  useEffect(() => {
    if (manager.entitystate != null && manager.entitystate > -1) {
      setManager({ ...manager, entitystatedesc: "Activa", entitystate:  1})     
    } 
    setAddresses(manager.addresses);
  }, [manager.medereentity])

  function createOrUpdateManager(manager: ManagerGeneralDataDTO) {
    return handleValidation(()=>{
      return manager.medereentity && manager.medereentity > 0 ? updateManager(manager) : createManager(manager)
    }, undefined, ["entitystatedesc", "medereentity"]).onSuccessResult
  }

  function saveManagerData() {
  
    let saveManagerData: ManagerGeneralDataDTO = {
      code: manager.code,
      medereentity: manager.medereentity,
      commercialname: manager.commercialname,
      addresses: addresses,
      entitystatedesc: "",
      entitystate: manager.entitystate,
    };
    createOrUpdateManager(saveManagerData)?.then(res => {
        if (res.status === 200) {
          //if (success) {
            setManager({ ...manager, medereentity: res.data })
            showMessage(toast, "Datos guardados", 'success')
            //dispatch(setNotification({ title: "Datos guardados", icon: 'pi-check-circle', typeOfNotification: ETypeOfNotification.INFO }))
            setHeaderView(saveManagerData.commercialname)
            setManager({ ...manager, medereentity: res.data })
          //} else showMessage(toast, "Error al guardar los datos", 'error')//dispatch(setNotification({ title: "Error al guardar los datos", desc: errormessage, icon: 'pi-times', typeOfNotification: ETypeOfNotification.INFO }))
        } else showMessage(toast, "Error al guardar los datos", 'error')//dispatch(setNotification({ title: "Error al guardar los datos", desc: res.statusText, icon: 'pi-times', typeOfNotification: ETypeOfNotification.INFO }))
    })                                      
  }

  function generateComboDataDTO(id:number, name:string):ComboDataDTO | null{
    if(!id || !name || id < 0)
      return null

    return {id, name}
  }

  return (
    <div className="ml-3.5 flex flex-column col-12 flex-column w-12">
      <div className="flex flex-column md:flex-row mb-2 w-12 align-items-end">
        <InputTextCustom
          floatLabel
          className='mr-2 w-12 md:w-3'
          label={"Código"}
          inputType={EInputTypes.TEXT}
          value={code}
          error={formErrors.code}
          onChange={(e: any) => {
            setManager({ ...manager, code: e.target.value })
            setFormErrors({ ...formErrors, code: false })
          }} />
        <InputTextCustom
          inputType={EInputTypes.TEXT}
          className="mr-2 w-12 md:w-4"
          label={"Nombre"}
          value={commercialname}
          floatLabel
          error={formErrors.commercialname}
          onChange={(e: any) => {
            setFormErrors({ ...formErrors, commercialname: false });
            setManager({ ...manager, commercialname: e.target.value })
          }}
        />
        <Combobox
          value={generateComboDataDTO(manager.entitystate, manager.entitystatedesc)}
          className="mr-2 w-12 md:w-4"
          getItems={getManagerStates}
          floatLabel
          label={"Estado"}
          optionLabel="name"
          error={formErrors.entitystate}
          setValue={(e: ComboDataDTO) => {
            if (e) {
              setFormErrors({ ...formErrors, entitystate: false })
              setManager({ ...manager, entitystate: e.id, entitystatedesc: e.name })
            } else setManager({ ...manager, entitystate: null })
          }} />
      </div>
      <div className="flex flex-column">
        <div className="flex flex-row align-items-end"><p className="primary font-medium mt-3 mr-2">Domicilio</p><i className="text-xl pi pi-info-circle  buttonSecondary2"></i></div>
        <div className="field mb-4" >
          <InputAddress
            getAllAddressTypes={getAllAddressTypesForPatientEntity}
            addresses={addresses}
            setAddresses={(addrs: Address[]) =>{
              setAddresses(addrs)
              setManager({...manager,addresses:addrs})
            } } />
        </div>
      </div>


      <div className="flex flex-row w-full justify-content-end">
        <div className="flex flex-row">
          <Button
            className="buttonMain"
            label={manager.medereentity && manager.medereentity > 0 ? "Guardar" : "Crear"}
            icon="pi pi-user-plus"
            iconPos="right"
            onClick={saveManagerData} />
        </div>
      </div>

    </div>
  )

}

